import getTargeting from "./getTargeting";

export default function getOverviewScript({ locale, tags = [], slug }) {
  return `
  var googletag = window.googletag || {};
  window.googletag = googletag;
  googletag.cmd = googletag.cmd || [];

  googletag.cmd.push(function(){
    gam_ros_top_mapping = googletag.sizeMapping()
                                  .addSize([1024, 0], [[468, 60], [728, 90], [970, 60], [970, 70], [970, 90]])
                                  .addSize([740, 0], [[728, 90], [468, 60]])
                                  .addSize([480, 0], [[468, 60]])
                                  .addSize([340, 0], [[300, 50], [300, 100], [320, 50], [320, 100], [300, 250]])
                                  .addSize([0, 0], [])
                                  .build();

    gam_ros_mid_mapping = googletag.sizeMapping()
                                  .addSize([1024, 0], [[468, 60]])
                                  .addSize([740, 0], [[468, 60]])
                                  .addSize([480, 0], [[468, 60]])
                                  .addSize([340, 0], [[300, 50], [300, 100], [320, 50], [320, 100], [300, 250], [320, 240], [320, 250]])
                                  .addSize([0, 0], [])
                                  .build();

    gam_ros_top = googletag.defineSlot('/21814830974/iamsterdam/ros_top', [[468, 60], [970, 90], [970, 70], [728, 90], [300, 50], [300, 100], [320, 100], [300, 250]], 'gam_ros_top').defineSizeMapping(gam_ros_top_mapping).addService(googletag.pubads());
    gam_ros_mid = googletag.defineSlot('/21814830974/iamsterdam/ros_mid', [[468, 60], [970, 90], [970, 70], [728, 90], [300, 50], [300, 100], [320, 100], [300, 250], [970, 250], [720, 300], [320, 240], [320, 250]], 'gam_ros_mid').defineSizeMapping(gam_ros_mid_mapping).addService(googletag.pubads());

    ${getTargeting({ locale, tags, slug })}
    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs();
    googletag.enableServices();
  });
`;
}
